// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__UlFwx","container":"Footer_container__yOX4B"};